import React from 'react';
import CommonModal from 'jbc-front/components/CommonModal';
import MemoForm from './MemoForm';
import { useTranslation } from 'react-i18next';

const MemoDataModal = ({ isOpen, hideModal, initialValues }) => {
  const { t } = useTranslation();
  const createMemo = t('features.Memos.components.MemoDataModal.Create_new_memo')
  const updateMemo = t('features.Memos.components.MemoDataModal.Update_memo')
  const header = initialValues && !!initialValues.id ? updateMemo : createMemo;

  return (
    <CommonModal ariaHideApp={false} {...{ isOpen, hideModal }}>
      <MemoForm cancelBtnClick={hideModal} {...{ initialValues }} header={header} />
    </CommonModal>
  );
};

export default MemoDataModal;
